import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "@/lib/api-client";
import { getRefreshInterval } from "@/lib/auto-refresh";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      // Live reload: poll on the globally-selected interval, and on tab focus.
      // Background-only so it never interrupts an in-progress interaction.
      refetchInterval: () => getRefreshInterval(),
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: true,
      retry: (failureCount, err) => {
        if (err instanceof ApiError) {
          if ([400, 401, 403, 404].includes(err.status)) return false;
          if (err.status === 429) return failureCount < 1;
        }
        return failureCount < 2;
      },
    },
  },
});
